import "./styles.css";
import { useExcelExport } from "../../../lib/queries/queriesAndMutations";
import { toast } from "react-toastify";
import icons from "../../../lib/icons";
import AlertButton from "../../../shared/AlertButton";

const ExcelPopupBtn = ({ searchTermRef, url }) => {
  const { mutateAsync: excelExport } = useExcelExport();

  const handleButtonClick = async () => {
    try {
      const res = await excelExport({ searchTermRef, url });

      if (res?.status === 200) {
        toast.success("خروجی اکسل");

        window.open(res.data.file_url);
      }
    } catch (error) {
      console.error("excelExport", error);
    }
  };

  return (

    <div>

         <AlertButton
                    onClick={handleButtonClick}
                    className="cursor-pointer flex justify-center items-center px-4 py-2 rounded-v-lg bg-neutral-20 gap-2"
                  >
                   <p className="text-dark  text-[10px] md:text-[16px] font-semibold">خروجی اکسل</p>
      <img className="w-5 h-5" src={icons.excel} alt="download" />
                  </AlertButton>
    </div>
   
  );
};

export default ExcelPopupBtn;
